<template>
    <div class="menu-lang" v-on:mouseover="isOpen = true" v-on:mouseleave="isOpen = false">
        <span class="title" :active="isOpen">
            {{ $i18n.locale }}
        </span>
        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66428 7L12.2822 0.999998" :stroke="isOpen ? '#FFED00' : '#ffffff'" stroke-linecap="square" />
            <path d="M0.999728 0.999997L6.61768 7" :stroke="isOpen ? '#FFED00' : '#ffffff'" stroke-linecap="square" />
        </svg>
        <transition name="fade" apear>
            <div class="sub-menu" v-if="isOpen">
                <span v-for="oLang in languages">
                    <router-link v-if="oLang != $i18n.locale" :to="{name: $route.name, params: {lang: oLang}}">
                        <img v-if="oLang != $i18n.locale" :src="`/static/img/flag-${oLang}.svg`" class="">
                        {{ oLang }}
                    </router-link>
                </span>
            </div>
        </transition>
    </div>
</template>

<script>
    import messages from '@/translations';
    export default {
        name: 'lang-selector',
        data() {
            return {
                languages: Object.keys(messages),
                isOpen: false,
            }
        },
        methods: {
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/lang-selector.vue